// export const environment = {
//   production: true,
//   domain: 'https://admin.shuwier.com/',
//   // endpoint: 'https://new-backend-shuwier.pomac.info/api', //---> Production
//   endpoint: 'https://backend.shuwier.com/api/admin', //---> Development
//   baseUrl: 'https://backend.shuwier.com/api', //---> Development
//   //'https://backend.shuwier.com/api',
//   // files: 'https://new-backend-shuwier.pomac.info/',
//   files: 'https://backend.shuwier.com/',
//   currentUserKey: 'shuwier_current_user',
// };


export const environment = {
  production: false,
  domain: 'https://admin.shuwier.com/',
  // endpoint: 'https://new-backend-shuwier.pomac.info/api', //---> Production
  endpoint: 'https://dev-backend.shuwier.com/api/admin', //---> Development
  baseUrl: 'https://dev-backend.shuwier.com/api', //---> Development
  //'https://dev-backend.shuwier.com/api',
  // files: 'https://new-dev-backend-shuwier.pomac.info/',
  files: 'https://dev-backend.shuwier.com/',
  currentUserKey: 'shuwier_current_user',
};


// export const environment = {
//   production: false,
//   domain: 'https://new-front-shuwier.pomac.info/',
//   // endpoint: 'https://new-backend-shuwier.pomac.info/api', //---> Production
//   endpoint: 'https://dev-backend-shuwier.pomac.info/api/admin', //---> Development
//   baseUrl: 'https://dev-backend-shuwier.pomac.info/api', //---> Development
//   //'https://backend.shuwier.com/api',
//   // files: 'https://new-backend-shuwier.pomac.info/',
//   files: 'https://dev-backend-shuwier.pomac.info/',
//   currentUserKey: 'shuwier_current_user',
// };
